import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    heading: "1. Objet",
    body: [
      "Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès et l'utilisation de la plateforme Helencia, accessible à l'adresse helencia.fr. L'inscription sur Helencia emporte acceptation sans réserve des présentes CGU.",
    ],
  },
  {
    heading: "2. Accès à la plateforme",
    body: [
      "Helencia est accessible gratuitement à tout utilisateur disposant d'un accès internet. L'inscription s'effectue via Google. L'utilisateur s'engage à fournir des informations exactes, complètes et à jour.",
      "Deux typologies de comptes coexistent :",
      [
        "Talent : personne physique souhaitant présenter son travail et postuler à des collaborations.",
        "Professionnel : personne physique ou morale souhaitant publier des collaborations et recruter des talents.",
      ],
    ],
  },
  {
    heading: "3. Contenu publié",
    body: [
      "L'utilisateur reste seul propriétaire des contenus qu'il publie (photos, textes, projets). Il concède à Helencia une licence non exclusive d'utilisation pour l'affichage sur la plateforme.",
      "L'utilisateur garantit détenir l'ensemble des droits nécessaires sur les contenus publiés et s'interdit de publier tout contenu illicite, diffamatoire, discriminatoire, à caractère sexuel ou portant atteinte aux droits d'un tiers.",
    ],
  },
  {
    heading: "4. Abonnement Premium",
    body: [
      "Les talents peuvent souscrire à un abonnement Premium (1, 3 ou 12 mois) via Stripe. L'abonnement est sans reconduction tacite : il prend fin automatiquement à l'échéance.",
      "Conformément à l'article L221-28 du Code de la consommation, l'utilisateur reconnaît renoncer à son droit de rétractation dès l'exécution immédiate du service.",
    ],
  },
  {
    heading: "5. Modération",
    body: [
      "Helencia se réserve le droit de modérer, masquer ou supprimer tout contenu ou compte contrevenant aux présentes CGU, à la loi ou à l'esprit de la maison. Toute décision est motivée et communiquée par email.",
    ],
  },
  {
    heading: "6. Responsabilité",
    body: [
      "Helencia agit en qualité de plateforme de mise en relation. Les missions, rémunérations et conditions d'exécution relèvent exclusivement de la relation entre le talent et le professionnel.",
      "Helencia n'est pas partie aux contrats conclus entre utilisateurs et ne saurait être tenue responsable de leur exécution.",
    ],
  },
  {
    heading: "7. Données personnelles",
    body: [
      "Le traitement des données personnelles est décrit dans notre Politique de confidentialité. Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité sur vos données.",
    ],
  },
  {
    heading: "8. Modifications",
    body: [
      "Helencia se réserve le droit de modifier les présentes CGU. Les utilisateurs seront informés de toute modification significative par email ou notification dans la plateforme.",
    ],
  },
  {
    heading: "9. Droit applicable",
    body: [
      "Les présentes CGU sont soumises au droit français. Tout litige relève de la compétence exclusive des tribunaux de Paris, sauf disposition légale contraire.",
    ],
  },
];

export default function CGU() {
  return <LegalPage title="Conditions Générales d'Utilisation" sections={SECTIONS} testid="cgu-page" />;
}
